<template>
	<div class="column">
		<Header></Header>
		<div class="colunm_main_box">
			<el-breadcrumb
				class="column_top_nav"
				separator-class="el-icon-arrow-right"
				style="font-size:14px;"
			>
				<span style="float:left;">当前位置：</span>
				<el-breadcrumb-item :to="{ path: '/' }"
					>首页</el-breadcrumb-item
				>
				<el-breadcrumb-item
					v-for="(item, index) in location"
					:key="index"
				>
					<span v-if="index != location.length - 1">{{ item }}</span>
					<span v-if="index == location.length - 1" class="active">{{
						item
					}}</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="column_center_box">
				<!-- 左侧导航 -->
				<div class="column_l_nav_box">
					<div class="column_l_nav_title">
						<span
							@click="enclumn_l_tab(0)"
							class="enclumn_l_tab active"
							>全国</span
						>
						<span @click="enclumn_l_tab(1)" class="enclumn_l_tab"
							>全球</span
						>
					</div>
					<div v-if="ifnav">
						<el-menu
							:default-active="currentChoose"
							:unique-opened="true"
							active-text-color="#4EAC41!important"
							class="el-menu-vertical-demo"
							@select="selectMenu"
							style="border-right:none;"
						>
							<div v-for="(item, index) in navData" :key="index">
								<el-submenu
									v-if="item.childrenList.length > 0"
									:index="item.id + ''"
									:title="item.title_name"
									class="column_l_nav_item"
								>
									<template slot="title">
										<span
											:style="
												currentChoose == item.id
													? 'color:rgb(78, 172, 65)'
													: ''
											"
											class="column_l_nav_style1"
											>{{ item.title_name }}</span
										>
									</template>
									<el-menu-item-group>
										<el-menu-item
											v-if="
												sitem.childrenList.length <= 0
											"
											v-for="(sitem,
											i) in item.childrenList"
											:key="i"
											:title="sitem.title_name"
											:index="sitem.id + ''"
											class="column_l_nav_style2"
											>.
											{{ sitem.title_name }}</el-menu-item
										>

										<el-submenu
											v-if="sitem.childrenList.length > 0"
											v-for="(sitem,
											i) in item.childrenList"
											:key="i"
											:title="sitem.title_name"
											:index="sitem.id + ''"
											class="column_l_nav_style2"
										>
											<template slot="title"
												><span
													class="column_l_nav_style1"
													>.
													{{ sitem.title_name }}</span
												></template
											>
											<el-menu-item
												v-for="(ssitem,
												j) in sitem.childrenList"
												:key="j"
												:title="ssitem.title_name"
												:index="ssitem.id + ''"
												class="column_l_nav_style2"
												>.
												{{
													ssitem.title_name
												}}</el-menu-item
											>
										</el-submenu>
									</el-menu-item-group>
								</el-submenu>
								<el-menu-item
									v-if="item.childrenList.length <= 0"
									:index="item.id + ''"
									class="column_l_nav_item"
									:title="item.title_name"
								>
									<span
										slot="title"
										class="column_l_nav_style1"
										>{{ item.title_name }}</span
									>
								</el-menu-item>
							</div>
							<!-- <el-menu-item index="2" class="column_l_nav_item">
                                <span slot="title" class="column_l_nav_style1">国内政策</span>
                            </el-menu-item>-->
						</el-menu>
					</div>
					<img
						class="column_l_nav_img"
						src="../../assets/main/navbg.png"
						alt=""
					/>
				</div>
				<!-- 右侧显示部分 -->
				<div class="column_r_box">
					<!-- 默认mode2 showType后台数据,6是全国地图，7是世界地图 -->
					<Mode6
						v-if="currentModel == '3-2'"
						:currentChoose="currentChoose"
						:regionLevel="regionLevel"
						:currentSource="currentSource"
					></Mode6>
					<Mode7
						v-if="currentModel == '3-4'"
						:currentChoose="currentChoose"
						:regionLevel="regionLevel"
						:currentSource="currentSource"
					></Mode7>
					<Mode81
						v-if="currentModel == '3-1'"
						:currentChoose="currentChoose"
						:regionLevel="regionLevel"
						:currentSource="currentSource"
					></Mode81>
					<Mode82
						v-if="currentModel == '3-3'"
						:currentChoose="currentChoose"
						:regionLevel="regionLevel"
						:currentSource="currentSource"
					></Mode82>
					<Mode6Child
						v-if="currentModel == '3-5'"
						:currentModel="currentModel"
						:currentChoose="currentChoose"
						:regionLevel="regionLevel"
						:currentSource="currentSource"
					></Mode6Child>
					<Mode7Child
						v-if="currentModel == '3-6'"
						:currentModel="currentModel"
						:currentChoose="currentChoose"
						:regionLevel="regionLevel"
						:currentSource="currentSource"
					></Mode7Child>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';
import Mode6 from './mode6'; //全国地图
import Mode6Child from './mode6Child'; //全国地图-子级指标
import Mode7 from './mode7'; //世界地图
import Mode7Child from './mode7Child'; //世界地图-子级指标
import Mode81 from './mode8-1'; //全国-只有表格
import Mode82 from './mode8-2'; //世界-只有表格

export default {
	props: {},
	components: {
		Header,
		Footer,
		Mode6,
		Mode7,
		Mode81,
		Mode82,
		Mode6Child,
		Mode7Child,
	},
	data() {
		return {
			navData: [], //导航栏数据
			topTitle: '二级栏目', //左侧导航头部标题
			currentChoose: '', //当前选中的栏目uid
			currentModel: '1-0', //当前调用的模板 1-0：全国能源概览 1-1：表格模板(默认)
			currentSource: null, //当前选中的栏目source
			regionLevel: '', //地区选择接口传值
			location: [], //获取位置数据
			ifword: 0, //判断当前是否是国内，国内：0，国外：1
			ifnav: true, //左侧nav是否显示
		};
	},
	computed: {},
	created() {
		let _name = magic.getUrlKey('name'); //获取url的参数name
		_name ? (this.topTitle = _name) : (this.topTitle = '二级栏目');

		let _uid = magic.getUrlKey('uid'); //获取url的参数uid
		_uid ? (this.currentChoose = _uid) : '';
	},
	mounted() {
		$('.column_l_nav_item .el-submenu__title').css({
			'font-size': '18px',
			color: '#8C8C8C',
		});

		let _id = magic.getUrlKey('id'); //获取url的参数id
		_id ? this.fetchNavList(_id) : (widnow.location.href = '/index.html');
		this.fetchLoaction(_id);
	},
	methods: {
		//全国、全球tab切换
		enclumn_l_tab(num) {
			$('.enclumn_l_tab').removeClass('active');
			$('.enclumn_l_tab')
				.eq(num)
				.addClass('active');
			this.ifword = num;
			let _id = magic.getUrlKey('id'); //获取url的参数id
			this.fetchNavList(_id);
		},
		//点击选择menu栏目
		selectMenu(id) {
			let _this = this;
			for (let i = 0; i < _this.navData.length; i++) {
				//console.log(_this.navData[i], 'res444');
				if (_this.navData[i].id == id) {
					_this.currentModel = _this.navData[i].showType;
					_this.regionLevel = _this.navData[i].regionLevel;
					_this.currentChoose = id;
					_this.currentSource = _this.currentSource =
						_this.navData[i].source;
					//console.log(_this.currentModel, 'res111');
				} else {
					if (_this.navData[i].childrenList.length > 0) {
						for (
							let j = 0;
							j < _this.navData[i].childrenList.length;
							j++
						) {
							if (_this.navData[i].childrenList[j].id == id) {
								_this.currentModel =
									_this.navData[i].childrenList[j].showType;
								_this.regionLevel =
									_this.navData[i].childrenList[
										j
									].regionLevel;
								_this.currentChoose = id;
								_this.currentSource =
									_this.navData[i].childrenList[j].source;
								//console.log(_this.currentModel, 'res222');
							} else {
								if (
									_this.navData[i].childrenList[j]
										.childrenList.length > 0
								) {
									for (
										let k = 0;
										k <
										_this.navData[i].childrenList[j]
											.childrenList.length;
										k++
									) {
										if (
											_this.navData[i].childrenList[j]
												.childrenList[k].id == id
										) {
											_this.currentModel =
												_this.navData[i].childrenList[
													j
												].childrenList[k].showType;
											_this.regionLevel =
												_this.navData[i].childrenList[
													j
												].childrenList[k].regionLevel;
											_this.currentChoose = id;
											_this.currentSource =
												_this.navData[i].childrenList[
													j
												].childrenList[k].source;

											//console.log(
											//_this.currentModel,
											//'res333'
											//);
										}
									}
								}
							}
						}
					}
				}
			}

			$('.colimn_l_top_select').css('color', '#3F433F');
		},
		//获取导航数据
		fetchLoaction(_id) {
			let _this = this;

			api.getMenu(_id).then((res) => {
				_this.location = res.data.reverse();
			});
		},
		//获取导航数据
		fetchNavList(_id) {
			let _this = this;

			if (_id == 76) {
				//能源数据
				api.getNavList2(_this.ifword).then((res) => {
					logicInfo(res);
				});
			}
			if (_id == 77) {
				//碳交易
				api.getNavList3(_this.ifword).then((res) => {
					logicInfo(res);
				});
			}
			if (_id == 79) {
				//碳排放
				api.getNavList4(_this.ifword).then((res) => {
					logicInfo(res);
				});
			}

			let logicInfo = (res) => {
				this.ifnav = false;
				this.navData = res.data;
				//console.log(res, 'res_1111');

				if (res.data.length > 0) {
					if (res.data[0].childrenList.length > 0) {
						if (
							res.data[0].childrenList[0].childrenList.length > 0
						) {
							_this.currentChoose =
								res.data[0].childrenList[0].childrenList[0].id +
								'';
							_this.currentModel =
								res.data[0].childrenList[0].childrenList[0].showType;
							_this.regionLevel =
								res.data[0].childrenList[0].childrenList[0].regionLevel;
						} else {
							_this.currentChoose =
								res.data[0].childrenList[0].id + '';
							_this.currentModel =
								res.data[0].childrenList[0].showType;
							_this.regionLevel =
								res.data[0].childrenList[0].regionLevel;
						}
						//console.log(_this.currentModel, '_this.currentModel1');
					} else {
						_this.currentChoose = res.data[0].id + '';
						_this.currentModel = res.data[0].showType;
						_this.regionLevel = res.data[0].regionLevel;
						//console.log(_this.currentModel, '_this.currentModel2');
					}
				}
				setTimeout(() => {
					_this.ifnav = true;
				}, 100);
			};
		},
	},
};
</script>
<style scoped lang="less">
.column {
	width: 100%;
	/* height: 100vh; */
	background: #f2f2f2;
}
.colunm_main_box {
	width: 1300px;
	margin: 0 auto;
	min-height: 600px;
}
.column_top_nav {
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1a1a1a;
	line-height: 26px;
	height: 54px;
	line-height: 54px;
}
.column_top_nav .active {
	color: #4eac41;
}
.column_center_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 50px;
}
// 左侧导航部分
.column_l_nav_box {
	float: left;
	width: 260px;
	// min-height: 460px;
	padding: 20px;
	background: #fff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
	position: relative;
	padding-bottom: 232px;
}
.column_l_nav_title {
	width: 260px;
	height: 46px;
	text-align: center;
	font-size: 18px;
	font-weight: 500;
	background: #edf7ec;
	border: 1px solid #328046;
	margin-bottom: 20px;
}
.column_l_nav_title span {
	display: inline-block;
	width: 130px;
	height: 46px;
	background: #edf7ec;
	// border: 1px solid #328046;
	text-align: center;
	line-height: 46px;
	float: left;
	cursor: pointer;
}
.column_l_nav_title span.active {
	background: #328046;
	color: #fff;
}
.column_l_nav_item {
	background: #f2f2f2;
	margin-bottom: 8px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
}
.column_l_nav_img {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
.column_l_nav_style1 {
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	// color: #3F433F;
}
.column_l_nav_style2 {
	border-bottom: 1px solid #f3f3f3;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #8c8c8c;
	display: block;
	width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.column_l_nav_style3 {
	// font-size: 13px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
	font-size: 18px;
}
.column_l_nav_style3:hover {
	color: #4eac41;
}
.colimn_l_top_select {
	width: 240px;
	height: 50px;
	background: #f2f2f2;
	border-radius: 1px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
	padding-left: 20px;
	line-height: 50px;
	margin-bottom: 20px;
	cursor: pointer;
}

// 右侧显示部分
.column_r_box {
	float: right;
	width: 950px;
	// padding:14px 30px;
	min-height: 578px;
	// background: #FFFFFF;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/view/discolumn/index.vue